import React, { useEffect } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from '../../styles/chat-model.module.css';

const CustomLink = ({ href, children }) => {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

// Wrap tables so wide content scrolls horizontally *inside* the chat bubble
// instead of overflowing the narrow side panel.
const CustomTable = ({ children }) => (
  <div className={styles.tableWrapper}>
    <table>{children}</table>
  </div>
);

// Shared config so the live (Typewriter) and historical (StaticMarkdown)
// renderers stay byte-for-byte identical. remark-gfm adds tables, strikethrough,
// task lists and autolinks on top of react-markdown's CommonMark baseline.
const REMARK_PLUGINS = [remarkGfm];
const MARKDOWN_COMPONENTS = {
  a: CustomLink,
  table: CustomTable,
};

// The AI reply arrives complete in one buffered WebSocket frame — there is nothing
// to stream. Render the whole markdown at once (no per-character re-parse / panel
// re-render), and fire the callbacks once so the parent clears its "typing" state
// and scrolls to the new message. Kept as the same component so index.jsx is untouched.
const Typewriter = ({ text, setIsTypeWriterActive, setTyping }) => {
  useEffect(() => {
    if (typeof setTyping === 'function') setTyping();
    if (typeof setIsTypeWriterActive === 'function') {
      setIsTypeWriterActive((n) => (typeof n === 'number' ? n + 1 : 1));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Markdown
      className={styles.markdownContainer}
      remarkPlugins={REMARK_PLUGINS}
      components={MARKDOWN_COMPONENTS}
    >
      {text ?? ''}
    </Markdown>
  );
};

export const StaticMarkdown = ({ text }) => (
  <Markdown
    className={styles.markdownContainer}
    remarkPlugins={REMARK_PLUGINS}
    components={MARKDOWN_COMPONENTS}
  >
    {text ?? ''}
  </Markdown>
);

export default Typewriter;
